const ChevronRightSvg = ({
  height = 12,
  width = 12,
  viewBox = '0 0 5 10',
}: {
  height?: any;
  width?: any;
  viewBox?: any;
}) => {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none">
      <path
        d="M3.10811 5L0 1.16667L0.945946 0L5 5L0.945946 10L0 8.83333L3.10811 5Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default ChevronRightSvg;
